export var EmailDraftState;
(function (EmailDraftState) {
    EmailDraftState["Generating"] = "generating";
    EmailDraftState["Draft"] = "draft";
    EmailDraftState["Exported"] = "exported";
})(EmailDraftState || (EmailDraftState = {}));
//# sourceMappingURL=email-draft-state.const.js.map